// Light only (20 Sep 2026). The toggle is gone from the header, so this applies
// the one theme the site has and nothing can select another.
//
// It deliberately IGNORES the old `cruxdiff-theme` value rather than reading it:
// a visitor who chose dark before the toggle was removed would otherwise be left
// in a theme with no control to leave it — a stored preference for a control that
// no longer exists is stale data, not a preference. The key is simply never read
// again; there is nothing to migrate and nothing to clear.
//
// The `[data-theme="dark"]` palette still exists in tokens.css. It costs nothing,
// keeps the token file honest about what the colours mean, and means restoring the
// toggle is a header change rather than a redesign. Nothing sets that attribute.
export function initTheme() {
  document.documentElement.dataset.theme = 'light';
  return 'light';
}
